import { useEffect } from 'react';

export function useOutsideClick<T extends HTMLElement>(ref: React.RefObject<T>, handler: () => void) {
	useEffect(() => {
		function onDown(e: MouseEvent | TouchEvent) {
			const el = ref.current;
			if (!el) return;
			if (!el.contains(e.target as Node)) handler();
		}
		document.addEventListener('mousedown', onDown);
		document.addEventListener('touchstart', onDown);
		return () => {
			document.removeEventListener('mousedown', onDown);
			document.removeEventListener('touchstart', onDown);
		};
	}, [ref, handler]);
}
